<app-ibase-crud-content [deleteRenforced]="true" [showHelpButton]="true"></app-ibase-crud-content>

<!-- BUGFIX: p-message disapear on modal close, making DOM dialog dynamic fix it -->
@if (helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <div>
            <p>This component allow you to create local users, and manage local and external users</p>

            <p-message severity="warn" styleClass="mt-2 mb-2">
                <span>
                    Users from SSO/LDAP/OAuth (external) don't need to be created manually, they will be created
                    automaticly upon their first connection to the application
                </span>
            </p-message>

            <p-message severity="info" styleClass="mt-2 mb-2">
                <span>
                    Only
                    <p-tag [style]="userTypeTags[0].style" [value]="userTypeTags[0].label" [rounded]="false"></p-tag>
                    and
                    <p-tag [style]="userTypeTags[1].style" [value]="userTypeTags[1].label" [rounded]="false"></p-tag>
                    can create local users and manage local/external users
                </span>
            </p-message>

            <p-table [value]="userTypeTags" stripedRows showGridlines [tableStyle]="{'min-width': '50rem'}">
                <ng-template #header>
                    <tr>
                        <th [ngStyle]="{'text-align': 'center'}"><b>User Type</b></th>
                        <th><b>Permissions / Description</b></th>
                    </tr>
                </ng-template>
                <ng-template #body let-current>
                    <tr>
                        <td [ngStyle]="{'text-align': 'center'}">
                            <p-tag [style]="current.style" [value]="current.label" [rounded]="false"></p-tag>
                        </td>
                        <td>{{ current.tooltip }}</td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="p-dialog-footer">
                <p-button
                    severity="secondary"
                    icon="pi pi-times"
                    type="button"
                    label="Close"
                    (click)="helpVisible = false"
                />
            </div>
        </div>
    </p-dialog>
}
